import TreeList, {
  LoadPanel,
  Column,
  Lookup,
} from "devextreme-react/tree-list";
import useGetDeliveryLocations from "../../../../Hooks/useGET/useGetDeliveryLocations";
import { urgencyKey } from "../../../../Components/OrderComponents/constants";
export default function ItemsTab(vendors) {
  const { deliveryLocations } = useGetDeliveryLocations();

  return (
    <>
      <TreeList
        id={`treeListItems${vendors[0].id}`}
        dataSource={vendors}
        maxHeight="300px"
        showRowLines={true}
        showBorders={true}
        itemsExpr="items"
        dataStructure="tree"
        onRowPrepared={onRowPrepared}
        elementAttr={{ class: "vendor-tree" }}
      >
        <LoadPanel enabled={true} />
        <Column
          width="auto"
          dataField="name"
          caption="Vendor"
          cellRender={vendorRender}
        />
        <Column width="auto" dataField="itemNumber" cellRender={cellRender} />
        <Column width="auto" dataField="itemName" caption="Item" />
        <Column
          width="auto"
          dataField="deliveryLocationId"
          caption="Delivery Location"
        >
          <Lookup
            dataSource={deliveryLocations}
            valueExpr="id"
            displayExpr="location"
          />
        </Column>
        <Column width="auto" dataField="pricePerItem" />
        <Column width="auto" dataField="quantity" />
        <Column width="auto" dataField="billingCode" />
        <Column width="auto" dataField="project" />
        <Column width="auto" dataField="billingName" />
        <Column width="auto" dataField="notes" />
      </TreeList>
    </>
  );
}
const vendorRender = (e) => {
  if (e.columnIndex === 0 && e.row.level === 0) {
    return `${e.data.name}: ${e?.data?.trackingNumber || ""}`;
  }
};

const cellRender = (e) => {
  return (
    <a href={e.data.url} target="_blank" rel="noreferrer">
      {e.data.itemNumber}
    </a>
  );
};

const onRowPrepared = (e) => {
  if (e.data) {
    if (e.data.isOutOfStock === true) {
      e.rowElement.style.backgroundColor = "#FF9A9A";
      e.rowElement.style.fontWeight = "bold";
    }
  }
};
